{
  "comment": "Mission 2 comms (S12 owns). Node shape: src/story/schemas.ts commsNodeSchema (a speaker, 1–3 lines, 1–4 replies; \"Show [log]\" replies; a reply without next ends the conversation). Node ids are unique across every comms file. Kell is short and transactional; Reyes is flat and speaks in facts (voice samples §2, §5). m2.not_yet: Kell below Holdfast 25. m2.offer → m2.offer.take: the package (the step completes on any reply at m2.offer.take). m2.scan.fine / m2.scan.waved: the patrol scan (a fine, never confiscation; waved through at high Authority standing, logged by Hale's office). m2.reyes: the meeting; a Show of a watch log is one node shorter than waiting. m2.reyes.book: the Watch book with the player's own sale dates (the signature beat, spec §5); m2.reyes.named is opened by the story link right after the book only when career.guardianKills has entries (src/story/m12.ts m2NamedLine): one line, no lecture. m2.raid: the briefing; m2.barge.<choice>: the fork's cost text; m2.after.<choice>: after the fork. m2.candle: Kell's Keep the Candle lit run (spec §16.2). Names are placeholders (spec §15 item 7).",
  "nodes": [
    {
      "id": "m2.not_yet",
      "speaker": "kell",
      "lines": ["I don't know you well enough yet.", "The Holdfast board's got work. Run some of it."],
      "replies": [{ "id": "ok", "text": "Fine." }]
    },
    {
      "id": "m2.offer",
      "speaker": "kell",
      "lines": [
        "I've got a package that needs a hull. Sealed. Don't scan it.",
        "Where it goes, you get at the jump. The Patrol parks a cutter on the short way."
      ],
      "replies": [
        { "id": "take", "text": "I'll take it.", "next": "m2.offer.take" },
        { "id": "what", "text": "What's in it?", "next": "m2.offer.what" },
        { "id": "why", "text": "Why me? You've got pilots.", "next": "m2.offer.why" },
        {
          "id": "show",
          "text": "Show him the queue board.",
          "show": { "thread": "evacuation" },
          "next": "m2.offer.show"
        }
      ]
    },
    {
      "id": "m2.offer.what",
      "speaker": "kell",
      "lines": ["Filters, mostly. And something that scans worse than filters."],
      "replies": [
        { "id": "take", "text": "Fine. Load it.", "next": "m2.offer.take" },
        { "id": "no", "text": "Not this run." }
      ]
    },
    {
      "id": "m2.offer.why",
      "speaker": "kell",
      "lines": [
        "That cutter boards every bone-white hull. Clean Authority standing gets waved through.",
        "Yours reads clean. That's worth 4,000 credits to me this week."
      ],
      "variants": {
        "corporation": [
          "That cutter boards every bone-white hull. A company registry in good Authority standing gets waved through.",
          "Yours reads clean. That's worth 4,000 credits to me this week."
        ]
      },
      "replies": [
        { "id": "take", "text": "Fine. Load it.", "next": "m2.offer.take" },
        { "id": "no", "text": "Not this run." }
      ]
    },
    {
      "id": "m2.offer.show",
      "speaker": "kell",
      "lines": [
        "Where did you pull that?",
        "The escorts are KT-3s. Old First Charter frames. Check the frame serial on your ship screen. Then load it."
      ],
      "replies": [{ "id": "take", "text": "Load it.", "next": "m2.offer.take" }]
    },
    {
      "id": "m2.offer.take",
      "speaker": "kell",
      "lines": ["It's in your bay. Somebody meets you at the other end.", "4,000 on delivery. Not before."],
      "replies": [{ "id": "ok", "text": "Going." }]
    },
    {
      "id": "m2.scan.fine",
      "speaker": "charterPatrol",
      "lines": [
        "Charter Patrol. Sealed container, undeclared. The fine is on your account.",
        "Container stays with you. Carry on."
      ],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m2.scan.waved",
      "speaker": "charterPatrol",
      "lines": ["Charter Patrol. Registry checks out. Proceed, and thank you."],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m2.reyes",
      "speaker": "reyes",
      "lines": [
        "You're Kell's runner. Put it on the deck and stay where I can see you.",
        "I don't know your hull. Kell vouching for it doesn't mean I do."
      ],
      "replies": [
        { "id": "show", "text": "Show her a Watch reading.", "show": { "thread": "watch" }, "next": "m2.reyes.show" },
        { "id": "wait", "text": "I'll wait.", "next": "m2.reyes.wait" }
      ]
    },
    {
      "id": "m2.reyes.show",
      "speaker": "reyes",
      "lines": ["Where did you get this.", "Fine. Then you can read the rest."],
      "replies": [{ "id": "ok", "text": "Go on.", "next": "m2.reyes.book" }]
    },
    {
      "id": "m2.reyes.wait",
      "speaker": "reyes",
      "lines": ["Then wait."],
      "replies": [{ "id": "ok", "text": "(wait)", "next": "m2.reyes.wait2" }]
    },
    {
      "id": "m2.reyes.wait2",
      "speaker": "reyes",
      "lines": ["Kell says you read things. Read this."],
      "replies": [{ "id": "ok", "text": "Send it.", "next": "m2.reyes.book" }]
    },
    {
      "id": "m2.reyes.book",
      "speaker": "reyes",
      "lines": ["Watch book 7. Fifty years off the Candle.", "Read the bottom of the page."],
      "replies": [
        { "id": "who", "text": "Who kept this before you?", "next": "m2.reyes.who" },
        { "id": "next", "text": "What now?", "next": "m2.raid" }
      ]
    },
    {
      "id": "m2.reyes.who",
      "speaker": "reyes",
      "lines": ["My mother. Then me."],
      "replies": [{ "id": "next", "text": "What now?", "next": "m2.raid" }]
    },
    {
      "id": "m2.reyes.named",
      "speaker": "reyes",
      "lines": ["Green-drive tug, Harrow field. You were the other ship. That's all I'm going to say about it."],
      "replies": [{ "id": "next", "text": "(say nothing)", "next": "m2.raid" }]
    },
    {
      "id": "m2.raid",
      "speaker": "reyes",
      "lines": [
        "There's a Tethys barge working the vein next door. We hit it at shift change.",
        "You're coming. What you do when we get there is yours."
      ],
      "replies": [{ "id": "come", "text": "I'm coming." }, { "id": "later", "text": "Not yet." }]
    },
    {
      "id": "m2.barge.help",
      "speaker": "reyes",
      "lines": [
        "Fly with the cell. Tethys Security calls it assault if a lawful ship sees you.",
        "The Holdfast remember who came. So does Tethys."
      ],
      "replies": [{ "id": "ok", "text": "Understood." }]
    },
    {
      "id": "m2.barge.stand_off",
      "speaker": "reyes",
      "lines": ["Hold off and watch. Nobody thanks you, nobody hunts you.", "I'll note that you were there."],
      "replies": [{ "id": "ok", "text": "Understood." }]
    },
    {
      "id": "m2.barge.warn",
      "speaker": "stationControl",
      "lines": [
        "Tethys Security channel. A tip is logged against your registry and earns standing, never payment.",
        "The Holdfast will know who called it."
      ],
      "replies": [{ "id": "ok", "text": "Understood." }]
    },
    {
      "id": "m2.after.help",
      "speaker": "reyes",
      "lines": [
        "Barge is venting. Two made the pod. The pilot didn't.",
        "Their names are on the hull. I read them before we fired."
      ],
      "replies": [
        { "id": "lessees", "text": "They were lessees. Same paint as mine.", "next": "m2.after.help.lessees" },
        { "id": "quiet", "text": "(say nothing)" }
      ]
    },
    {
      "id": "m2.after.help.lessees",
      "speaker": "reyes",
      "lines": [
        "I know what they are. Lease crews paying off the same yellow you are.",
        "The gate doesn't count kids. It counts tonnes."
      ],
      "variants": {
        "owned": [
          "I know what they are. Lease crews. Paying off the yellow you paid off.",
          "The gate doesn't count kids. It counts tonnes."
        ],
        "corporation": [
          "I know what they are. Lease crews. Your company sells to the same buyers.",
          "The gate doesn't count kids. It counts tonnes."
        ]
      },
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m2.after.stand_off",
      "speaker": "reyes",
      "lines": ["You watched. The book has room for that.", "Keep a meter on next time you mine."],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m2.after.warn",
      "speaker": "stationControl",
      "lines": ["Barge crew withdrew ahead of contact. Tethys Mining Combine notes your cooperation on your registry."],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m2.candle",
      "speaker": "kell",
      "lines": [
        "The Harrow runs on fuel cells and whatever we can spare. Somebody has to carry them.",
        "No clock on it. The Holdfast pays what it can."
      ],
      "replies": [{ "id": "yes", "text": "I'll carry them." }, { "id": "no", "text": "Not this run." }]
    }
  ]
}
